import classNames from "classnames"
import PropTypes from "prop-types"
import { buttonLinkPropTypes } from "../../../utils/types"
import Loader from "../loader"

const Button = ({
  button,
  appearance = "dark",
  compact = false,
  handleClick,
  loading = false,
  type,
  children
}) => {
  return (
    <button onClick={handleClick} type={type}>
      <div
        className={classNames(
          // Common classes
          "flex hover:text-crimson border-crimson justify-center w-auto text-center font-semibold text-base md:text-sm border-2 rounded-md",
          // Full-size button
          {
            "px-4 py-2": compact === false,
          },
          // Compact button
          {
            "px-2 py-2": compact === true,
          },
          // Specific to when the button is fully dark
          {
            "bg-sunset text-white border-sunset": appearance === "dark",
          },
          // Specific to when the button is dark outlines
          {
            "text-primary-600 border-primary-600":
              appearance === "dark-outline",
          },
          // Specific to when the button is fully white
          {
            "bg-white text-primary-600 border-white": appearance === "white",
          },
          // Specific to when the button is white outlines
          {
            "text-white border-white": appearance === "white-outline",
          }
        )}
      >
        {loading && <Loader />}
        {button?.text}
        {/* {button?.icon} */}
        {children}
      </div>
    </button>
  )
}

Button.propTypes = {
  button: buttonLinkPropTypes,
  appearance: PropTypes.oneOf([
    "dark",
    "white-outline",
    "white",
    "dark-outline",
    // "image",
  ]),
  compact: PropTypes.bool,
}

export default Button